import { defineMessages } from 'react-intl'

const scope = `procurify.components.ExportPreview`

export default defineMessages({
  emptyStateLineOne: {
    id: `${scope}.emptyStateLineOne`,
    defaultMessage: 'No data will be exported with the selected filters',
  },
  emptyStateLineTwo: {
    id: `${scope}.emptyStateLineTwo`,
    defaultMessage: 'Change your filters and try again',
  },
  previewOverlayText: {
    id: `${scope}.previewOverlayText`,
    defaultMessage: 'PREVIEW OF DATA EXPORT',
  },
})
